import { connect } from 'react-redux';
import React from "react";
import { getInit } from '../../redux/actions/init.action';
import { withTranslation } from "react-i18next";
import Plans from '../../views/Plans';
import HomeFooter from "components/Footer/HomeFooter.jsx";
import { motion } from "framer-motion";
import {
    Row,
    Col
  } from "reactstrap";
import HomeNavbar from "components/Navbars/HomeNavbar.jsx";
import { setBeacon } from '../../redux/actions/rLink.action';
import smartswitches from "assets/img/home/smartswitches.png";
import smartalarms from "assets/img/home/smartalarms.png";
import storagemonitors from "assets/img/home/storagemonitors.png";
import gameinformations from "assets/img/home/gameinformations.png";
import gameevents from "assets/img/home/gameevents.png";
import settingsevents from "assets/img/home/settingsevents.png";
import map from "assets/img/home/map.png";


const featuresList = [
  {
    name: "smartSwitches",
    image: smartswitches
  },
  {
    name: "smartAlarms",
    image: smartalarms
  },
  {
    name: "storageMonitors",
    image: storagemonitors
  },
  {
    name: "gameInformations",
    image: gameinformations
  },
  {
    name: "gameEvents",
    image: gameevents
  },
  {
    name: "map",
    image: map
  },
  {
    name: "easy",
    image: settingsevents
  }
];

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHelper: false
    };
  }
  componentDidMount = async () => {
    await this.props.getInit();
    setTimeout(() => {
      const beacon = document.getElementById(typeof(chrome) == "object" ? "chromeAddon" : "mozAddon");
      const isPresent = beacon && beacon.innerHTML === "1.0.1";
      this.props.setBeacon(isPresent)
      isPresent || this.setState({ showHelper: true });
    }, 250);
  }
  render() {
    //<div className="image" style={ { background: `url("${feature.image}") center / contain no-repeat`} }/>
    return (
      <div className="wrapper">
        <div className="main-panel fixBg">
          <HomeNavbar/>
          <div className="homeContent">
              <div className="mainVideo">
                <div className="gradient"></div>
                <video autoPlay="autoplay" loop="loop" muted="muted">
                  <source src="https://rustlink.io/static/media/rust-official.mp4" type="video/mp4"></source>Your browser does not support the video tag.
                </video>
                
              </div>
              { this.state.showHelper && <div className="getStarted d-none d-sm-block">
                <h2 className="introducing text-center">
                  {this.props.t('getstarted.title')}
                </h2>
                <div className="container">
                  <div onClick={() => { window.location.href = typeof(chrome) == "object" ? `/chrome` : `/mozilla` }} className="step clickable">
                    <img alt="logo" src="https://rustlink.io/static/media/app.png"></img>
                    <div>{this.props.t('getstarted.install')}</div>
                  </div>
                  <div className="step"><i className="tim-icons icon-minimal-right"></i></div>
                  <div className="step">
                    <img alt="logo" src="https://rustlink.io/static/media/logo256.png"></img>
                    <div>{this.props.t('getstarted.getback')}</div>
                  </div>
                  <div className="step"><i className="tim-icons icon-minimal-right"></i></div>
                  <div className="step">
                    <img alt="wiretool" src="https://rustlink.io/static/media/wiretool.png"></img>
                    <div>{this.props.t('getstarted.startpairing')}</div>
                  </div>
                </div>
              </div> }
              <div className="homeFeatures">
                <h2 className="introducing text-center">
                    {this.props.t('showcase.introducing')}
                </h2>
                {featuresList.map((feature, key) => {
                    return( 
                      <div key={feature.name} className="feature">
                        <motion.div initial={{ opacity: 0.5, x: key % 2 ? -100 : 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 1 } }}>
                          <Row>
                            <Col md="6" xs="12">
                              <img className="tcenter image" alt={feature.title} src={feature.image}/>
                            </Col>
                            <Col md="6" xs="12" className="feature_description text-left">
                                <div className="title">{this.props.t(`showcase.${feature.name}.title`)}</div>
                                <div className="description">{this.props.t(`showcase.${feature.name}.desc`)}</div>
                            </Col>
                          </Row>
                        </motion.div>
                      </div>
                    )
                })}
              </div>
              <div className="homePricing">
                <Plans></Plans>
              </div>
          </div>
          <HomeFooter fluid />
        </div>
      </div>
    );
  };
};

const mapDispatchToProps = {
  setBeacon,
  getInit
};

export default withTranslation('home')(connect(null, mapDispatchToProps)(Home));